// /** 7.1.2026
// * tier-moq-cart.js
// *
// * Runs on the cart page AND cart drawer. Gated by window.TIER_MOQ_ENABLED.
// * MOQ quantity clamping (enforceAllLineItems) runs in both places. The
// * split-tier and tier-ceiling WARNING BANNERS are both currently DISABLED
// * (see "SPLIT TIER GUARD" and "TIER CEILING GUARD" notes below) -- the
// * functions that build them are left in the file in case they're wanted
// * back later, but nothing calls them from init()/scheduleRefresh().
// *
// * Reads each line item's `properties._tier_min` (and, for the ceiling
// * check below, `properties._tier_max` / `_tier_next_price`) via Shopify's
// * /cart.js endpoint (NOT by scraping visible DOM text) -- because Shopify
// * hides underscore-prefixed line item properties from default cart
// * rendering, so the values we need are very likely never present in the
// * visible DOM at all. /cart.js always returns full property data
// * regardless of whether the theme displays it.
// *
// * We match each cart.js line item to its on-page quantity <input> by
// * variant id (Shopify includes a "key" and "variant_id" on each line
// * item, and most theme cart inputs carry a matching id/data attribute).
// *
// * SPLIT TIER GUARD (DISABLED): If the same base product appears more than
// * once in the cart under different tier variants, the customer is missing
// * out on a better price. checkForSplitTiers() still builds this out, but
// * is no longer called from init()/scheduleRefresh(). The function is left
// * in place in case it's wanted back later.
// *
// * TIER CEILING GUARD (DISABLED): If a customer bumps a line item's
// * quantity past the upper bound of the tier variant they added (e.g.
// * using the cart's own +/- stepper), the cart price stays locked to the
// * tier they originally selected -- Shopify does not auto-reprice line
// * items when quantity changes in the cart. checkForTierCeiling() still
// * detects this using `properties._tier_max`, but is no longer called --
// * no banner is shown. The function is left in place in case it's wanted
// * back later.
// *
// * REQUIRES: `_tier_max` (and optionally `_tier_next_price`, used only for
// * messaging) must be set as hidden line item properties at add-to-cart
// * time on the product page, the same way `_tier_min` already is. If
// * `_tier_max` is not present on a line item, the ceiling check silently
// * skips that line -- it will not throw or block anything.
// *
// * IMPORTANT: This remains a client-side guard only -- a customer could
// * still hit /cart/change.js directly via devtools, bypassing this
// * entirely. Full enforcement requires a Shopify Function or app.
// */
// (function () {
//   if (!window.TIER_MOQ_ENABLED) return;

//   document.addEventListener('DOMContentLoaded', init);
//   if (document.readyState !== 'loading') init();

//   var cartData = null;
//   var cartObserver = null;

//   // IDs of the warning banners we inject so we can remove/update them independently.
//   var SPLIT_BANNER_ID = 'tier-moq-split-warning';
//   var CEILING_BANNER_ID = 'tier-moq-ceiling-warning';

//   // The split-tier / ceiling banners are only meaningful (and only laid out
//   // correctly) on the actual cart page. The cart *drawer* reuses this same
//   // script for MOQ clamping, but its markup is a narrow flyout, not the
//   // cart page's main column -- injecting a banner there breaks formatting.
//   // Gate the banners to /cart itself; MOQ clamping still runs everywhere.
//   function isCartPage() {
//     return /^\/cart(\/|$)/.test(window.location.pathname);
//   }

//   function init() {
//     refreshCartData().then(function () {
//       enforceAllLineItems();
//       // Both banners (split-tier yellow and tier-ceiling blue) are
//       // disabled. Clean up any stale ones left over from a previous
//       // version of this script.
//       if (isCartPage()) {
//         removeBanner(SPLIT_BANNER_ID);
//         removeBanner(CEILING_BANNER_ID);
//       }
//       observeCart();
//     });
//   }

//   function refreshCartData() {
//     return fetch('/cart.js')
//       .then(function (r) { return r.json(); })
//       .then(function (data) {
//         cartData = data;
//       })
//       .catch(function (err) {
//         console.warn('[tier-moq-cart] Failed to fetch /cart.js', err);
//       });
//   }

//   var CART_CONTAINER_SELECTOR =
//     '[data-cart-items], .cart-items, #CartDrawer, cart-drawer, .cart, #cart';
//   var REFRESH_DEBOUNCE_MS = 150;
//   var refreshDebounceTimer = null;

//   function scheduleRefresh() {
//     clearTimeout(refreshDebounceTimer);
//     refreshDebounceTimer = setTimeout(function () {
//       refreshCartData().then(function () {
//         enforceAllLineItems();
//       });
//     }, REFRESH_DEBOUNCE_MS);
//   }

//   function observeCart() {
//     var target = document.querySelector(CART_CONTAINER_SELECTOR);

//     if (target) {
//       attachDeepObserver(target);
//       return;
//     }

//     // No cart-specific container exists yet -- e.g. an empty drawer that
//     // hasn't been rendered until the first add-to-cart. Previously this
//     // fell back to watching document.body's *entire* subtree, which meant
//     // any DOM change anywhere on the page (image swaps, review widgets,
//     // upsell apps -- not just cart activity) triggered a /cart.js fetch
//     // plus a full-page quantity-input scan, with no debouncing. Clicking
//     // "Add to cart" is exactly when the most unrelated DOM churn happens
//     // (drawer building, recommendations re-rendering), so that fallback
//     // was the main source of the slowdown. Instead, watch body *shallowly*
//     // (direct children only, not the whole subtree) just to notice when a
//     // real cart container shows up, then switch to watching that directly.
//     var shallowObserver = new MutationObserver(function () {
//       var found = document.querySelector(CART_CONTAINER_SELECTOR);
//       if (found) {
//         shallowObserver.disconnect();
//         attachDeepObserver(found);
//       }
//     });
//     shallowObserver.observe(document.body, { childList: true, subtree: false });
//   }

//   function attachDeepObserver(target) {
//     cartObserver = new MutationObserver(scheduleRefresh);
//     cartObserver.observe(target, { childList: true, subtree: true });
//   }

//   /**
//    * showBanner/removeBanner mutate the same subtree the MutationObserver
//    * above is watching. Without this guard, inserting or removing a banner
//    * triggers the observer, which refetches /cart.js and re-runs the checks,
//    * which touches the banner again -- a feedback loop that fires extra
//    * network requests and DOM churn on every cart update. We briefly
//    * disconnect the observer around our own writes and reconnect on the next
//    * tick, once our mutation has settled.
//    */
//   function withObserverPaused(fn) {
//     if (cartObserver) cartObserver.disconnect();
//     fn();
//     if (cartObserver) {
//       setTimeout(function () {
//         var target = document.querySelector(CART_CONTAINER_SELECTOR) || document.body;
//         cartObserver.observe(target, { childList: true, subtree: true });
//       }, 0);
//     }
//   }

//   // ---------------------------------------------------------------------------
//   // SPLIT TIER DETECTION
//   // ---------------------------------------------------------------------------

//   /**
//    * Groups cart line items by product_id. If any product appears more than
//    * once (meaning the customer has two different tier variants of the same
//    * product), calculate what the combined quantity would be, work out the
//    * best available tier, and warn the customer.
//    */
//   function checkForSplitTiers() {
//     if (!cartData) return;

//     // Group items by product_id
//     var byProduct = {};
//     cartData.items.forEach(function (item) {
//       var pid = String(item.product_id);
//       if (!byProduct[pid]) byProduct[pid] = [];
//       byProduct[pid].push(item);
//     });

//     // Find any product with more than one line item (split tier situation)
//     var splitProducts = [];
//     Object.keys(byProduct).forEach(function (pid) {
//       if (byProduct[pid].length > 1) {
//         splitProducts.push(byProduct[pid]);
//       }
//     });

//     if (splitProducts.length === 0) {
//       removeBanner(SPLIT_BANNER_ID);
//       return;
//     }

//     // Build a helpful message for each split product
//     var messages = splitProducts.map(function (lines) {
//       var title = lines[0].product_title || lines[0].title.split(' - ')[0];
//       var totalQty = lines.reduce(function (sum, l) { return sum + l.quantity; }, 0);
//       var tiers = lines.map(function (l) {
//         return l.quantity + ' \u00d7 ' + (l.variant_title || 'tier');
//       }).join(' + ');
//       return (
//         '\u26a0\ufe0f \u201c' + title + '\u201d is split across ' + lines.length + ' price tiers (' + tiers + '). ' +
//         'Your combined quantity is ' + totalQty + ' \u2014 you may qualify for a better price. ' +
//         'Please remove one line, go back to the product page, and add ' + totalQty + ' as a single order.'
//       );
//     });

//     showBanner(SPLIT_BANNER_ID, messages, {
//       background: '#fff3cd',
//       border: '#f0ad4e',
//       color: '#7a5200',
//       note: 'You can still check out, but you may be paying more than necessary.'
//     });
//   }

//   // ---------------------------------------------------------------------------
//   // TIER CEILING DETECTION (better price available at current quantity)
//   // ---------------------------------------------------------------------------

//   /**
//    * Checks each line item against `properties._tier_max`. If the customer
//    * has bumped quantity (e.g. via the cart's own +/- stepper) past the
//    * upper bound of the tier variant they originally added, the cart price
//    * is stuck at the old, more expensive tier -- Shopify does not reprice
//    * line items just because quantity changed in the cart. We flag it and
//    * tell them to go re-enter the quantity on the product page.
//    */
//   function checkForTierCeiling() {
//     if (!cartData) return;

//     var breaches = [];
//     cartData.items.forEach(function (item) {
//       var tierMax = getTierMax(item);
//       if (!tierMax) return; // no ceiling data on this line (or it's an open-ended top tier); skip

//       if (item.quantity > tierMax) {
//         breaches.push({ item: item, tierMax: tierMax });
//       }
//     });

//     if (breaches.length === 0) {
//       removeBanner(CEILING_BANNER_ID);
//       return;
//     }

//     var messages = breaches.map(function (breach) {
//       var item = breach.item;
//       var tierMax = breach.tierMax;
//       var title = item.product_title || item.title.split(' - ')[0];
//       var tierRange = getTierRangeLabel(item);

//       return (
//         '\u201c' + title + '\u201d: ' + item.quantity + ' units are still priced at the ' + tierRange +
//         ' rate. Go back to the product page and re-enter ' + item.quantity + ' to get the better price.'
//       );
//     });

//     showBanner(CEILING_BANNER_ID, messages, {
//       background: '#d6e4ff',
//       border: '#3366ff',
//       color: '#1a2f7a',
//       note: 'You can still check out, but you may be paying more than necessary.'
//     });
//   }

//   /**
//    * Resolves the lower bound (MOQ) of a line item's current price tier.
//    *
//    * Previously this was read directly from `properties._tier_min` in
//    * enforceAllLineItems(). That hidden property is set at add-to-cart time
//    * on the product page, and for at least one product (Rainbow Pixie /
//    * 35g jar / 48-per-case) it was getting set to the wrong value -- the
//    * cart line showed "35-49 cases" (i.e. an MOQ of 35) but carried a
//    * _tier_min of 75, so clamp() kept forcing the quantity back up to 75
//    * any time the customer tried to lower it.
//    *
//    * To make this resilient to a bad hidden property, we now parse the
//    * floor directly out of variant_title first -- the same range that's
//    * already visibly displayed to the customer as "35-49 cases", so it
//    * can't drift out of sync with what they see. `properties._tier_min`
//    * is now only a fallback, used for lines whose title doesn't encode a
//    * range (e.g. a single fixed-MOQ variant with no "-max" component).
//    *
//    * Mirrors getTierMax() below, just reading group 1 instead of group 2.
//    */
//   function getTierMin(item) {
//     var title = item.variant_title || item.title || '';

//     // Matches "(35-49" or "35-49" inside the variant title.
//     var rangeMatch = title.match(/(\d+)\s*-\s*(\d+)/);
//     if (rangeMatch) {
//       var min = parseInt(rangeMatch[1], 10);
//       if (!isNaN(min)) return min;
//     }

//     // No parsable range in the title -- fall back to the hidden property.
//     if (item.properties && item.properties._tier_min) {
//       var explicit = parseInt(item.properties._tier_min, 10);
//       if (!isNaN(explicit)) return explicit;
//     }

//     return null;
//   }

//   /**
//    * Resolves the upper bound of a line item's current price tier.
//    *
//    * 1. Prefers an explicit `properties._tier_max` if you ever add one as a
//    *    hidden line item property on the product page.
//    * 2. Otherwise, parses it out of `variant_title`, which already encodes
//    *    the range in this store's naming convention, e.g.:
//    *      "1 lb (by weight) / (130-199 / 1 lb bags)"  -> 199
//    *      "(500+ / 1 lb bags)"                          -> null (open-ended,
//    *                                                       no ceiling to flag)
//    *
//    * Returns a number, or null if no ceiling could be determined.
//    */
//   function getTierMax(item) {
//     if (item.properties && item.properties._tier_max) {
//       var explicit = parseInt(item.properties._tier_max, 10);
//       if (explicit && !isNaN(explicit)) return explicit;
//     }

//     var title = item.variant_title || item.title || '';

//     // Matches "(130-199" or "130-199" inside the variant title.
//     var rangeMatch = title.match(/(\d+)\s*-\s*(\d+)/);
//     if (rangeMatch) {
//       var max = parseInt(rangeMatch[2], 10);
//       return isNaN(max) ? null : max;
//     }

//     // "(500+" style open-ended top tier -- intentionally no ceiling.
//     return null;
//   }

//   /**
//    * Pulls just the tier-range portion out of variant_title for display,
//    * e.g. "1 lb (by weight) / (130-199 / 1 lb bags)" -> "130-199 / 1 lb bags"
//    * instead of echoing the full jar-size + tier string back to the customer.
//    */
//   function getTierRangeLabel(item) {
//     var title = item.variant_title || item.title || '';
//     var parenMatch = title.match(/\(([^)]+)\)\s*$/);
//     return parenMatch ? parenMatch[1] : (title || 'your current tier');
//   }

//   // ---------------------------------------------------------------------------
//   // BANNER RENDERING (shared by both checks above)
//   // ---------------------------------------------------------------------------

//   function showBanner(bannerId, messages, theme) {
//     var banner = document.createElement('div');
//     banner.id = bannerId;
//     banner.style.cssText = [
//       'background: ' + theme.background,
//       'border: 2px solid ' + theme.border,
//       'border-radius: 6px',
//       'padding: 14px 18px',
//       'margin: 16px 0',
//       'font-size: 14px',
//       'line-height: 1.5',
//       'color: ' + theme.color
//     ].join(';');

//     messages.forEach(function (msg) {
//       var p = document.createElement('p');
//       p.style.margin = '0 0 8px';
//       p.textContent = msg;
//       banner.appendChild(p);
//     });

//     var note = document.createElement('p');
//     note.style.cssText = 'margin: 8px 0 0; font-weight: bold;';
//     note.textContent = theme.note;
//     banner.appendChild(note);

//     withObserverPaused(function () {
//       var existing = document.getElementById(bannerId);
//       if (existing) existing.remove();

//       // Insert before the cart items or at the top of the cart form.
//       // If the other banner is already present, stack this one directly
//       // after it rather than re-inserting above the cart items again.
//       var otherBannerId = bannerId === SPLIT_BANNER_ID ? CEILING_BANNER_ID : SPLIT_BANNER_ID;
//       var otherBanner = document.getElementById(otherBannerId);

//       if (otherBanner && otherBanner.parentNode) {
//         otherBanner.parentNode.insertBefore(banner, otherBanner.nextSibling);
//         return;
//       }

//       var insertBefore =
//         document.querySelector('[data-cart-items], .cart-items, .cart__items, table.cart-items') ||
//         document.querySelector('form[action="/cart"]') ||
//         document.body.firstElementChild;

//       if (insertBefore && insertBefore.parentNode) {
//         insertBefore.parentNode.insertBefore(banner, insertBefore);
//       } else {
//         document.body.insertBefore(banner, document.body.firstChild);
//       }
//     });
//   }

//   function removeBanner(bannerId) {
//     var existing = document.getElementById(bannerId);
//     if (!existing) return;
//     withObserverPaused(function () { existing.remove(); });
//   }

//   function disableCheckout() {
//     getCheckoutButtons().forEach(function (btn) {
//       btn.disabled = true;
//       btn.dataset.tierMoqDisabled = 'true';
//       btn.title = 'Please consolidate duplicate tier items before checking out.';
//     });
//   }

//   function enableCheckout() {
//     getCheckoutButtons().forEach(function (btn) {
//       if (btn.dataset.tierMoqDisabled) {
//         btn.disabled = false;
//         delete btn.dataset.tierMoqDisabled;
//         btn.title = '';
//       }
//     });
//   }

//   function getCheckoutButtons() {
//     return Array.prototype.slice.call(document.querySelectorAll(
//       '[name="checkout"], button[data-checkout], a[href="/checkout"], .cart__checkout-button, input[type="submit"][name="checkout"]'
//     ));
//   }

//   // ---------------------------------------------------------------------------
//   // MOQ ENFORCEMENT (unchanged)
//   // ---------------------------------------------------------------------------

//   function enforceAllLineItems() {
//     if (!cartData) return;

//     var qtyInputs = document.querySelectorAll(
//       'input[name="updates[]"], input.quantity-selector__input, input.quantity__input, input[name^="quantity"], [data-quantity-input]'
//     );

//     qtyInputs.forEach(function (input) {
//       var lineItem =
//         input.closest('[data-cart-item], .cart-item, tr.cart-item, .cart__row, [class*="cart-item"]') ||
//         input.closest('tr') ||
//         (input.parentElement ? input.parentElement.parentElement : null);
//       if (!lineItem) return;

//       var variantId = resolveVariantId(input, lineItem);
//       if (!variantId) return;

//       var cartLine = cartData.items.find(function (item) {
//         return String(item.variant_id) === String(variantId);
//       });
//       if (!cartLine || !cartLine.properties) return;

//       var tierMin = getTierMin(cartLine);
//       if (!tierMin || isNaN(tierMin)) return;

//       input.setAttribute('min', tierMin);
//       input.setAttribute('data-tier-min', tierMin);

//       if (!input.dataset.tierMoqBound) {
//         input.dataset.tierMoqBound = 'true';
//         input.addEventListener('change', function () { clamp(input, tierMin, variantId, lineItem); });
//         input.addEventListener('blur', function () { clamp(input, tierMin, variantId, lineItem); });
//       }

//       var minusBtn = lineItem.querySelector(
//         '[data-quantity-decrease], .quantity__button[name="minus"], button[data-cart-quantity-minus], .quantity-selector__button-wrapper--minus button, .quantity-selector__button-wrapper--minus'
//       );
//       if (minusBtn && !minusBtn.dataset.tierMoqBound) {
//         minusBtn.dataset.tierMoqBound = 'true';
//         minusBtn.addEventListener('click', function () {
//           setTimeout(function () { clamp(input, tierMin, variantId, lineItem); }, 150);
//         });
//       }
//     });
//   }

//   function resolveVariantId(input, lineItem) {
//     if (input.id) {
//       var match = input.id.match(/updates_(\d+)/);
//       if (match) return match[1];
//     }
//     return (
//       input.getAttribute('data-variant-id') ||
//       lineItem.getAttribute('data-variant-id') ||
//       null
//     );
//   }

//   function clamp(input, min, variantId, lineItem) {
//     var val = parseInt(input.value, 10);
//     if (isNaN(val) || val < min) {
//       input.value = min;
//       input.dispatchEvent(new Event('change', { bubbles: true }));
//       console.log('[tier-moq-cart] Clamped quantity to tier minimum', min, 'for variant', variantId);
//       if (lineItem) showMinQtyNotice(lineItem, variantId, min);
//     }
//   }

//   /**
//    * Small inline message shown next to a line item's quantity control
//    * whenever the customer tries to drop below that tier's MOQ (via typing,
//    * blur, or the cart's own minus button). Unlike the split-tier/ceiling
//    * banners above, this is per-line and works identically on the cart page
//    * and in the drawer -- it doesn't need isCartPage(), since it anchors to
//    * the specific line item rather than the top of the page layout.
//    *
//    * Auto-dismisses after a few seconds rather than trying to clear itself
//    * on the next valid input -- clamp() dispatches its own 'change' event
//    * after resetting the value, which would otherwise immediately re-fire
//    * this same input's change handler and hide the notice right after
//    * showing it.
//    */
//   var MIN_QTY_NOTICE_HIDE_MS = 6000;

//   function showMinQtyNotice(lineItem, variantId, min) {
//     var noticeId = 'tier-moq-min-notice-' + variantId;

//     withObserverPaused(function () {
//       var notice = document.getElementById(noticeId);
//       if (!notice) {
//         notice = document.createElement('div');
//         notice.id = noticeId;
//         notice.style.cssText = [
//           'color: #b3261e',
//           'font-size: 12px',
//           'line-height: 1.4',
//           'margin-top: 6px',
//           'max-width: 320px'
//         ].join(';');

//         var qtyControl = lineItem.querySelector(
//           'input[name="updates[]"], input.quantity-selector__input, input.quantity__input, input[name^="quantity"], [data-quantity-input]'
//         );
//         var anchor = qtyControl
//           ? (qtyControl.closest('.quantity-selector, .quantity__input-group, .quantity') || qtyControl.parentElement)
//           : null;

//         if (anchor && anchor.parentNode) {
//           anchor.parentNode.insertBefore(notice, anchor.nextSibling);
//         } else {
//           lineItem.appendChild(notice);
//         }
//       }

//       notice.textContent =
//         'The minimum qty at the selected tier is ' + min + '. If you\u2019re looking for a lesser ' +
//         'quantity, please visit the product page and adjust the quantity to fall into the right tier.';

//       clearTimeout(notice._tierMoqHideTimer);
//       notice._tierMoqHideTimer = setTimeout(function () {
//         removeMinQtyNotice(variantId);
//       }, MIN_QTY_NOTICE_HIDE_MS);
//     });
//   }

//   function removeMinQtyNotice(variantId) {
//     var notice = document.getElementById('tier-moq-min-notice-' + variantId);
//     if (!notice) return;
//     clearTimeout(notice._tierMoqHideTimer);
//     withObserverPaused(function () { notice.remove(); });
//   }
// })();
/** 7.1.2026
* tier-moq-cart.js
*
* Runs on the cart page AND cart drawer. Gated by window.TIER_MOQ_CART_ENABLED
* (see full explanation further down).
* MOQ quantity clamping (enforceAllLineItems) runs in both places. The
* split-tier and tier-ceiling WARNING BANNERS are both currently DISABLED
* (see "SPLIT TIER GUARD" and "TIER CEILING GUARD" notes below) -- the
* functions that build them are left in the file in case they're wanted
* back later, but nothing calls them from init()/scheduleRefresh().
*
* Reads each line item's `properties._tier_min` (and, for the ceiling
* check below, `properties._tier_max` / `_tier_next_price`) via Shopify's
* /cart.js endpoint (NOT by scraping visible DOM text) -- because Shopify
* hides underscore-prefixed line item properties from default cart
* rendering, so the values we need are very likely never present in the
* visible DOM at all. /cart.js always returns full property data
* regardless of whether the theme displays it.
*
* We match each cart.js line item to its on-page quantity <input> by
* variant id (Shopify includes a "key" and "variant_id" on each line
* item, and most theme cart inputs carry a matching id/data attribute).
*
* SPLIT TIER GUARD (DISABLED): If the same base product appears more than
* once in the cart under different tier variants, the customer is missing
* out on a better price. checkForSplitTiers() still builds this out, but
* is no longer called from init()/scheduleRefresh(). The function is left
* in place in case it's wanted back later.
*
* TIER CEILING GUARD (DISABLED): If a customer bumps a line item's
* quantity past the upper bound of the tier variant they added (e.g.
* using the cart's own +/- stepper), the cart price stays locked to the
* tier they originally selected -- Shopify does not auto-reprice line
* items when quantity changes in the cart. checkForTierCeiling() still
* detects this using `properties._tier_max`, but is no longer called --
* no banner is shown. The function is left in place in case it's wanted
* back later.
*
* REQUIRES: `_tier_max` (and optionally `_tier_next_price`, used only for
* messaging) must be set as hidden line item properties at add-to-cart
* time on the product page, the same way `_tier_min` already is. If
* `_tier_max` is not present on a line item, the ceiling check silently
* skips that line -- it will not throw or block anything.
*
* IMPORTANT: This remains a client-side guard only -- a customer could
* still hit /cart/change.js directly via devtools, bypassing this
* entirely. Full enforcement requires a Shopify Function or app.
*
* ENABLING: Gated by window.TIER_MOQ_CART_ENABLED -- deliberately a
* SEPARATE flag from window.TIER_MOQ_ENABLED (which tier-moq-product.js
* uses). This script needs to run site-wide, since the cart drawer is
* typically embedded on every page, not just /cart. tier-moq-product.js's
* own guard is `if (!window.TIER_MOQ_ENABLED) return;` -- if this script
* reused that same flag and it got set site-wide, tier-moq-product.js
* would stop bailing out early on non-product pages and go hunting the
* DOM for a quantity input / tier select anywhere a page happens to have
* something matching. A dedicated flag keeps the two scripts fully
* independent regardless of where each is loaded.
*/
(function () {
  if (!window.TIER_MOQ_CART_ENABLED) return;

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  var cartData = null;
  var cartObserver = null;
  var cartContainerEl = null;

  // IDs of the warning banners we inject so we can remove/update them independently.
  var SPLIT_BANNER_ID = 'tier-moq-split-warning';
  var CEILING_BANNER_ID = 'tier-moq-ceiling-warning';

  // The split-tier / ceiling banners are only meaningful (and only laid out
  // correctly) on the actual cart page. The cart *drawer* reuses this same
  // script for MOQ clamping, but its markup is a narrow flyout, not the
  // cart page's main column -- injecting a banner there breaks formatting.
  // Gate the banners to /cart itself; MOQ clamping still runs everywhere.
  function isCartPage() {
    return /^\/cart(\/|$)/.test(window.location.pathname);
  }

  function init() {
    refreshCartData().then(function () {
      enforceAllLineItems();
      // Both banners (split-tier yellow and tier-ceiling blue) are
      // disabled. Clean up any stale ones left over from a previous
      // version of this script.
      if (isCartPage()) {
        removeBanner(SPLIT_BANNER_ID);
        removeBanner(CEILING_BANNER_ID);
      }
      observeCart();
    });
  }

  function refreshCartData() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cartData = data;
      })
      .catch(function (err) {
        console.warn('[tier-moq-cart] Failed to fetch /cart.js', err);
      });
  }

  var CART_CONTAINER_SELECTOR =
    '[data-cart-items], .cart-items, .cartitems--container, .cartitems--list, .cartitems, #CartDrawer, cart-drawer, .cart, #cart';
  var REFRESH_DEBOUNCE_MS = 150;
  var refreshDebounceTimer = null;

  function scheduleRefresh() {
    clearTimeout(refreshDebounceTimer);
    refreshDebounceTimer = setTimeout(function () {
      refreshCartData().then(function () {
        enforceAllLineItems();
      });
    }, REFRESH_DEBOUNCE_MS);
  }

  function observeCart() {
    var target = document.querySelector(CART_CONTAINER_SELECTOR);

    if (target) {
      attachDeepObserver(target);
      return;
    }

    // No cart-specific container exists yet -- e.g. an empty drawer that
    // hasn't been rendered until the first add-to-cart. Previously this
    // fell back to watching document.body's *entire* subtree, which meant
    // any DOM change anywhere on the page (image swaps, review widgets,
    // upsell apps -- not just cart activity) triggered a /cart.js fetch
    // plus a full-page quantity-input scan, with no debouncing. Clicking
    // "Add to cart" is exactly when the most unrelated DOM churn happens
    // (drawer building, recommendations re-rendering), so that fallback
    // was the main source of the slowdown. Instead, watch body *shallowly*
    // (direct children only, not the whole subtree) just to notice when a
    // real cart container shows up, then switch to watching that directly.
    var shallowObserver = new MutationObserver(function () {
      var found = document.querySelector(CART_CONTAINER_SELECTOR);
      if (found) {
        shallowObserver.disconnect();
        attachDeepObserver(found);
      }
    });
    shallowObserver.observe(document.body, { childList: true, subtree: false });
  }

  function attachDeepObserver(target) {
    cartContainerEl = target;
    cartObserver = new MutationObserver(scheduleRefresh);
    cartObserver.observe(target, { childList: true, subtree: true });
  }

  /**
   * showBanner/removeBanner mutate the same subtree the MutationObserver
   * above is watching. Without this guard, inserting or removing a banner
   * triggers the observer, which refetches /cart.js and re-runs the checks,
   * which touches the banner again -- a feedback loop that fires extra
   * network requests and DOM churn on every cart update. We briefly
   * disconnect the observer around our own writes and reconnect on the next
   * tick, once our mutation has settled.
   */
  function withObserverPaused(fn) {
    if (cartObserver) cartObserver.disconnect();
    fn();
    if (cartObserver) {
      setTimeout(function () {
        // Re-observe the same real cart container found earlier. No
        // document.body fallback here -- falling back to the whole
        // document would silently reintroduce the exact site-wide
        // mutation flood this file's own header comments describe fixing
        // (every unrelated DOM change anywhere on the page triggering a
        // /cart.js refetch). If the container genuinely isn't there
        // anymore, leave the observer disconnected; observeCart() will
        // pick it back up cleanly on the next real cart refresh.
        var target = document.querySelector(CART_CONTAINER_SELECTOR);
        if (target) {
          cartContainerEl = target;
          cartObserver.observe(target, { childList: true, subtree: true });
        }
      }, 0);
    }
  }

  // ---------------------------------------------------------------------------
  // SPLIT TIER DETECTION
  // ---------------------------------------------------------------------------

  /**
   * Groups cart line items by product_id. If any product appears more than
   * once (meaning the customer has two different tier variants of the same
   * product), calculate what the combined quantity would be, work out the
   * best available tier, and warn the customer.
   */
  function checkForSplitTiers() {
    if (!cartData) return;

    // Group items by product_id
    var byProduct = {};
    cartData.items.forEach(function (item) {
      var pid = String(item.product_id);
      if (!byProduct[pid]) byProduct[pid] = [];
      byProduct[pid].push(item);
    });

    // Find any product with more than one line item (split tier situation)
    var splitProducts = [];
    Object.keys(byProduct).forEach(function (pid) {
      if (byProduct[pid].length > 1) {
        splitProducts.push(byProduct[pid]);
      }
    });

    if (splitProducts.length === 0) {
      removeBanner(SPLIT_BANNER_ID);
      return;
    }

    // Build a helpful message for each split product
    var messages = splitProducts.map(function (lines) {
      var title = lines[0].product_title || lines[0].title.split(' - ')[0];
      var totalQty = lines.reduce(function (sum, l) { return sum + l.quantity; }, 0);
      var tiers = lines.map(function (l) {
        return l.quantity + ' \u00d7 ' + (l.variant_title || 'tier');
      }).join(' + ');
      return (
        '\u26a0\ufe0f \u201c' + title + '\u201d is split across ' + lines.length + ' price tiers (' + tiers + '). ' +
        'Your combined quantity is ' + totalQty + ' \u2014 you may qualify for a better price. ' +
        'Please remove one line, go back to the product page, and add ' + totalQty + ' as a single order.'
      );
    });

    showBanner(SPLIT_BANNER_ID, messages, {
      background: '#fff3cd',
      border: '#f0ad4e',
      color: '#7a5200',
      note: 'You can still check out, but you may be paying more than necessary.'
    });
  }

  // ---------------------------------------------------------------------------
  // TIER CEILING DETECTION (better price available at current quantity)
  // ---------------------------------------------------------------------------

  /**
   * Checks each line item against `properties._tier_max`. If the customer
   * has bumped quantity (e.g. via the cart's own +/- stepper) past the
   * upper bound of the tier variant they originally added, the cart price
   * is stuck at the old, more expensive tier -- Shopify does not reprice
   * line items just because quantity changed in the cart. We flag it and
   * tell them to go re-enter the quantity on the product page.
   */
  function checkForTierCeiling() {
    if (!cartData) return;

    var breaches = [];
    cartData.items.forEach(function (item) {
      var tierMax = getTierMax(item);
      if (!tierMax) return; // no ceiling data on this line (or it's an open-ended top tier); skip

      if (item.quantity > tierMax) {
        breaches.push({ item: item, tierMax: tierMax });
      }
    });

    if (breaches.length === 0) {
      removeBanner(CEILING_BANNER_ID);
      return;
    }

    var messages = breaches.map(function (breach) {
      var item = breach.item;
      var tierMax = breach.tierMax;
      var title = item.product_title || item.title.split(' - ')[0];
      var tierRange = getTierRangeLabel(item);

      return (
        '\u201c' + title + '\u201d: ' + item.quantity + ' units are still priced at the ' + tierRange +
        ' rate. Go back to the product page and re-enter ' + item.quantity + ' to get the better price.'
      );
    });

    showBanner(CEILING_BANNER_ID, messages, {
      background: '#d6e4ff',
      border: '#3366ff',
      color: '#1a2f7a',
      note: 'You can still check out, but you may be paying more than necessary.'
    });
  }

  /**
   * Resolves the lower bound (MOQ) of a line item's current price tier.
   *
   * Previously this was read directly from `properties._tier_min` in
   * enforceAllLineItems(). That hidden property is set at add-to-cart time
   * on the product page, and for at least one product (Rainbow Pixie /
   * 35g jar / 48-per-case) it was getting set to the wrong value -- the
   * cart line showed "35-49 cases" (i.e. an MOQ of 35) but carried a
   * _tier_min of 75, so clamp() kept forcing the quantity back up to 75
   * any time the customer tried to lower it.
   *
   * To make this resilient to a bad hidden property, we now parse the
   * floor directly out of variant_title first -- the same range that's
   * already visibly displayed to the customer as "35-49 cases", so it
   * can't drift out of sync with what they see. `properties._tier_min`
   * is now only a fallback, used for lines whose title doesn't encode a
   * range (e.g. a single fixed-MOQ variant with no "-max" component).
   *
   * Mirrors getTierMax() below, just reading group 1 instead of group 2.
   */
  function getTierMin(item) {
    var title = item.variant_title || item.title || '';

    // Matches "(35-49" or "35-49" inside the variant title.
    var rangeMatch = title.match(/(\d+)\s*-\s*(\d+)/);
    if (rangeMatch) {
      var min = parseInt(rangeMatch[1], 10);
      if (!isNaN(min)) return min;
    }

    // No parsable range in the title -- fall back to the hidden property.
    if (item.properties && item.properties._tier_min) {
      var explicit = parseInt(item.properties._tier_min, 10);
      if (!isNaN(explicit)) return explicit;
    }

    return null;
  }

  /**
   * Resolves the upper bound of a line item's current price tier.
   *
   * 1. Prefers an explicit `properties._tier_max` if you ever add one as a
   *    hidden line item property on the product page.
   * 2. Otherwise, parses it out of `variant_title`, which already encodes
   *    the range in this store's naming convention, e.g.:
   *      "1 lb (by weight) / (130-199 / 1 lb bags)"  -> 199
   *      "(500+ / 1 lb bags)"                          -> null (open-ended,
   *                                                       no ceiling to flag)
   *
   * Returns a number, or null if no ceiling could be determined.
   */
  function getTierMax(item) {
    if (item.properties && item.properties._tier_max) {
      var explicit = parseInt(item.properties._tier_max, 10);
      if (explicit && !isNaN(explicit)) return explicit;
    }

    var title = item.variant_title || item.title || '';

    // Matches "(130-199" or "130-199" inside the variant title.
    var rangeMatch = title.match(/(\d+)\s*-\s*(\d+)/);
    if (rangeMatch) {
      var max = parseInt(rangeMatch[2], 10);
      return isNaN(max) ? null : max;
    }

    // "(500+" style open-ended top tier -- intentionally no ceiling.
    return null;
  }

  /**
   * Pulls just the tier-range portion out of variant_title for display,
   * e.g. "1 lb (by weight) / (130-199 / 1 lb bags)" -> "130-199 / 1 lb bags"
   * instead of echoing the full jar-size + tier string back to the customer.
   */
  function getTierRangeLabel(item) {
    var title = item.variant_title || item.title || '';
    var parenMatch = title.match(/\(([^)]+)\)\s*$/);
    return parenMatch ? parenMatch[1] : (title || 'your current tier');
  }

  // ---------------------------------------------------------------------------
  // BANNER RENDERING (shared by both checks above)
  // ---------------------------------------------------------------------------

  function showBanner(bannerId, messages, theme) {
    var banner = document.createElement('div');
    banner.id = bannerId;
    banner.style.cssText = [
      'background: ' + theme.background,
      'border: 2px solid ' + theme.border,
      'border-radius: 6px',
      'padding: 14px 18px',
      'margin: 16px 0',
      'font-size: 14px',
      'line-height: 1.5',
      'color: ' + theme.color
    ].join(';');

    messages.forEach(function (msg) {
      var p = document.createElement('p');
      p.style.margin = '0 0 8px';
      p.textContent = msg;
      banner.appendChild(p);
    });

    var note = document.createElement('p');
    note.style.cssText = 'margin: 8px 0 0; font-weight: bold;';
    note.textContent = theme.note;
    banner.appendChild(note);

    withObserverPaused(function () {
      var existing = document.getElementById(bannerId);
      if (existing) existing.remove();

      // Insert before the cart items or at the top of the cart form.
      // If the other banner is already present, stack this one directly
      // after it rather than re-inserting above the cart items again.
      var otherBannerId = bannerId === SPLIT_BANNER_ID ? CEILING_BANNER_ID : SPLIT_BANNER_ID;
      var otherBanner = document.getElementById(otherBannerId);

      if (otherBanner && otherBanner.parentNode) {
        otherBanner.parentNode.insertBefore(banner, otherBanner.nextSibling);
        return;
      }

      var insertBefore =
        document.querySelector('[data-cart-items], .cart-items, .cart__items, table.cart-items') ||
        document.querySelector('form[action="/cart"]') ||
        document.body.firstElementChild;

      if (insertBefore && insertBefore.parentNode) {
        insertBefore.parentNode.insertBefore(banner, insertBefore);
      } else {
        document.body.insertBefore(banner, document.body.firstChild);
      }
    });
  }

  function removeBanner(bannerId) {
    var existing = document.getElementById(bannerId);
    if (!existing) return;
    withObserverPaused(function () { existing.remove(); });
  }

  function disableCheckout() {
    getCheckoutButtons().forEach(function (btn) {
      btn.disabled = true;
      btn.dataset.tierMoqDisabled = 'true';
      btn.title = 'Please consolidate duplicate tier items before checking out.';
    });
  }

  function enableCheckout() {
    getCheckoutButtons().forEach(function (btn) {
      if (btn.dataset.tierMoqDisabled) {
        btn.disabled = false;
        delete btn.dataset.tierMoqDisabled;
        btn.title = '';
      }
    });
  }

  function getCheckoutButtons() {
    return Array.prototype.slice.call(document.querySelectorAll(
      '[name="checkout"], button[data-checkout], a[href="/checkout"], .cart__checkout-button, input[type="submit"][name="checkout"]'
    ));
  }

  // ---------------------------------------------------------------------------
  // MOQ ENFORCEMENT
  // ---------------------------------------------------------------------------

  var QTY_INPUT_SELECTOR =
    'input[name="updates[]"], input.quantity-selector__input, input.quantity__input, input[name^="quantity"], [data-quantity-input]';
  var MINUS_BTN_SELECTOR =
    '[data-quantity-decrease], .quantity__button[name="minus"], button[data-cart-quantity-minus], .quantity-selector__button-wrapper--minus button, .quantity-selector__button-wrapper--minus';
  var LINE_ITEM_SELECTOR =
    '[data-cart-item], .cart-item, tr.cart-item, .cart__row, [class*="cart-item"]';

  function findLineItemFor(input) {
    return (
      input.closest(LINE_ITEM_SELECTOR) ||
      input.closest('tr') ||
      (input.parentElement ? input.parentElement.parentElement : null)
    );
  }

  function enforceAllLineItems() {
    if (!cartData) return;

    // Previously this queried document.querySelectorAll(...) -- i.e. the
    // WHOLE page, not just the cart. Since cart drawers are embedded
    // site-wide, that meant this could match the product page's own
    // quantity input (tier-moq-product.js uses [name="quantity"], which
    // input[name^="quantity"] below also matches) and attach a second,
    // conflicting set of clamp/change listeners on top of that script's
    // own guarding logic. Scoping to the actual discovered cart container
    // makes that structurally impossible.
    //
    // init() calls this before observeCart() has had a chance to run, so
    // seed cartContainerEl here too on that first cold-start call rather
    // than only inside attachDeepObserver().
    if (!cartContainerEl) {
      cartContainerEl = document.querySelector(CART_CONTAINER_SELECTOR);
    }
    if (!cartContainerEl) return;

    ensureDelegatedEnforcementListeners();

    var qtyInputs = cartContainerEl.querySelectorAll(QTY_INPUT_SELECTOR);

    qtyInputs.forEach(function (input) {
      var lineItem = findLineItemFor(input);
      if (!lineItem) return;

      var variantId = resolveVariantId(input, lineItem);
      if (!variantId) return;

      var cartLine = cartData.items.find(function (item) {
        return String(item.variant_id) === String(variantId);
      });
      if (!cartLine || !cartLine.properties) return;

      var tierMin = getTierMin(cartLine);
      if (!tierMin || isNaN(tierMin)) return;

      input.setAttribute('min', tierMin);
      input.setAttribute('data-tier-min', tierMin);

      var minusBtn = lineItem.querySelector(MINUS_BTN_SELECTOR);

      // Keep the minus button's disabled state in sync on every pass
      // (page load, cart refresh, after a correction) so it's never left
      // clickable while already sitting at the tier floor.
      updateMinusBtnState(minusBtn, input, tierMin);
    });
  }

  function updateMinusBtnState(minusBtn, input, min) {
    if (!minusBtn) return;
    var val = parseInt(input.value, 10);
    var atFloor = isNaN(val) || val <= min;
    minusBtn.disabled = atFloor;
    minusBtn.setAttribute('aria-disabled', atFloor ? 'true' : 'false');
    minusBtn.style.opacity = atFloor ? '0.4' : '';
    minusBtn.style.cursor = atFloor ? 'not-allowed' : '';
  }

  function resolveVariantId(input, lineItem) {
    if (input.id) {
      var match = input.id.match(/updates_(\d+)/);
      if (match) return match[1];
    }
    return (
      input.getAttribute('data-variant-id') ||
      (lineItem && lineItem.getAttribute('data-variant-id')) ||
      null
    );
  }

  function clamp(input, min, variantId, lineItem, minusBtn) {
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < min) {
      input.value = min;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      console.log('[tier-moq-cart] Blocked reduction below tier minimum', min, 'for variant', variantId);
      if (lineItem) showMinQtyNotice(lineItem, variantId, min);
    }
    if (minusBtn) updateMinusBtnState(minusBtn, input, min);
  }

  /**
   * Delegated, CAPTURE-PHASE listeners attached ONCE on the cart container
   * itself (an ANCESTOR of every quantity input/button) -- not on each
   * input/button individually, and this is the actual bug fix, not just a
   * refactor.
   *
   * Previously we attached 'change'/'blur'/'click' listeners directly on
   * each input/button, alongside whatever listener the theme's own
   * cart-item component already has on that same element. When two
   * listeners are bound to the SAME element, the browser fires them in
   * *registration order* -- not by our-script-vs-theme-script priority.
   * If the theme's listener happened to be registered first (e.g. because
   * tier-moq-cart.js loads after the theme's own cart JS), it would fire
   * FIRST, on the RAW value the customer typed/decremented to (e.g. "2"),
   * and immediately kick off its own async /cart/change.js update using
   * that invalid value -- all before our correction ever ran. Our
   * correction would then run a moment later and dispatch its OWN
   * synthetic 'change' event with the fixed value (11), triggering a
   * SECOND, overlapping /cart/change.js request. Whichever of those two
   * requests happened to resolve last would win -- a race that could
   * leave the actual cart quantity at the invalid value even though the
   * on-screen notice correctly reported the MOQ. That's exactly what
   * happened: quantity visually landed on 2 while the "minimum is 11"
   * notice was showing.
   *
   * Listening in the CAPTURE phase on an ANCESTOR sidesteps the ordering
   * problem entirely: capture-phase listeners on ancestors always run
   * BEFORE any listener bound directly to the target element, regardless
   * of script load order or registration order at the target. So we see
   * the invalid value first, correct it, and call stopPropagation() --
   * which prevents the theme's own listener from ever running on the bad
   * value in the first place. We then dispatch a fresh 'change' event
   * afterward so the theme still gets notified, but only with the
   * corrected value.
   */
  var delegatedListenersBound = false;

  function ensureDelegatedEnforcementListeners() {
    if (delegatedListenersBound || !cartContainerEl) return;
    delegatedListenersBound = true;

    cartContainerEl.addEventListener('change', handleQtyCorrectionEvent, true);
    cartContainerEl.addEventListener('blur', handleQtyCorrectionEvent, true);
    cartContainerEl.addEventListener('click', handleMinusButtonClick, true);
  }

  function handleQtyCorrectionEvent(evt) {
    var input = evt.target;
    if (!input || !input.matches || !input.matches(QTY_INPUT_SELECTOR)) return;

    var min = parseInt(input.getAttribute('data-tier-min'), 10);
    if (isNaN(min)) return;

    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < min) {
      // Block the ORIGINAL event here, before the theme's own listener on
      // this input ever sees the invalid value.
      evt.stopPropagation();

      var lineItem = findLineItemFor(input);
      var variantId = resolveVariantId(input, lineItem);
      var minusBtn = lineItem ? lineItem.querySelector(MINUS_BTN_SELECTOR) : null;

      clamp(input, min, variantId, lineItem, minusBtn);
    }
  }

  function handleMinusButtonClick(evt) {
    var btn = evt.target.closest ? evt.target.closest(MINUS_BTN_SELECTOR) : null;
    if (!btn) return;

    var lineItem = btn.closest(LINE_ITEM_SELECTOR) || btn.closest('tr');
    if (!lineItem) return;

    var input = lineItem.querySelector(QTY_INPUT_SELECTOR);
    if (!input) return;

    var min = parseInt(input.getAttribute('data-tier-min'), 10);
    if (isNaN(min)) return;

    var val = parseInt(input.value, 10);
    if (!isNaN(val) && val <= min) {
      // Already at the floor -- block the decrement before the theme's
      // own click handler on this button ever runs.
      evt.preventDefault();
      evt.stopPropagation();
      var variantId = resolveVariantId(input, lineItem);
      showMinQtyNotice(lineItem, variantId, min);
      return;
    }

    // Otherwise let the click proceed normally (we did not stop it), then
    // re-check shortly after -- covers step sizes > 1 landing below the
    // floor in a single click.
    setTimeout(function () {
      var variantId = resolveVariantId(input, lineItem);
      var minusBtn = lineItem.querySelector(MINUS_BTN_SELECTOR);
      clamp(input, min, variantId, lineItem, minusBtn);
    }, 150);
  }


  /**
   * Popover anchored directly under a specific line item's quantity
   * control, appended to document.body -- deliberately OUTSIDE the cart
   * container's own DOM subtree (cartContainerEl). The message previously
   * lived as a sibling of the quantity control INSIDE the line item, but
   * clamp() dispatches a synthetic 'change' event after resetting the
   * value, which triggers the theme's own cart-update flow (a real
   * /cart/change.js call and a re-render of that line item's markup).
   * That re-render was wiping the inline notice out of the DOM almost
   * instantly -- well before its timer ran out -- which is why it read as
   * a "flash." Living outside that subtree means the theme's re-render
   * can't touch the popover itself; we just track the quantity control's
   * on-screen position (via getBoundingClientRect(), refreshed on scroll/
   * resize, and re-resolved by variant id if the theme swaps in a new DOM
   * node for that line) and keep the popover pinned under it.
   *
   * Dismissed manually via the close (x) button rather than a timer, per
   * request -- multiple popovers (one per variant) can be open at once if
   * more than one line is flagged.
   */
  var TOAST_CONTAINER_ID = 'tier-moq-toast-container';
  var toastAnchors = {}; // variantId -> the quantity <input> it's pinned under
  var toastRepositionBound = false;

  function ensureToastContainer() {
    var container = document.getElementById(TOAST_CONTAINER_ID);
    if (container) return container;
    container = document.createElement('div');
    container.id = TOAST_CONTAINER_ID;
    document.body.appendChild(container);
    return container;
  }

  function findQtyInputForVariant(variantId) {
    if (!cartContainerEl) return null;
    var inputs = cartContainerEl.querySelectorAll(
      'input[name="updates[]"], input.quantity-selector__input, input.quantity__input, input[name^="quantity"], [data-quantity-input]'
    );
    for (var i = 0; i < inputs.length; i++) {
      var li =
        inputs[i].closest('[data-cart-item], .cart-item, tr.cart-item, .cart__row, [class*="cart-item"]') ||
        inputs[i].closest('tr') ||
        (inputs[i].parentElement ? inputs[i].parentElement.parentElement : null);
      if (!li) continue;
      if (String(resolveVariantId(inputs[i], li)) === String(variantId)) return inputs[i];
    }
    return null;
  }

  function positionToast(toast) {
    var variantId = toast.dataset.variantId;
    var anchor = toastAnchors[variantId];

    if (!anchor || !anchor.isConnected) {
      anchor = findQtyInputForVariant(variantId);
      if (anchor) toastAnchors[variantId] = anchor;
    }

    if (!anchor) {
      // Line item is no longer in the cart -- nothing sensible left to
      // anchor to (e.g. it was removed entirely).
      removeMinQtyNotice(variantId);
      return;
    }

    var rect = anchor.getBoundingClientRect();
    var toastWidth = toast.offsetWidth;

    // Center under the quantity control...
    var left = rect.left + (rect.width / 2) - (toastWidth / 2);

    // ...then clamp to the viewport with an 8px margin on each side, so on
    // narrow (mobile) screens the popover can't extend past the edge of
    // the page -- which is exactly what was putting the close button out
    // of reach.
    var viewportWidth = document.documentElement.clientWidth;
    var minLeft = 8;
    var maxLeft = viewportWidth - toastWidth - 8;
    if (left < minLeft) left = minLeft;
    if (left > maxLeft) left = Math.max(minLeft, maxLeft);

    toast.style.top = (rect.bottom + 8) + 'px';
    toast.style.left = left + 'px';
  }

  function repositionAllToasts() {
    var container = document.getElementById(TOAST_CONTAINER_ID);
    if (!container) return;
    Array.prototype.slice.call(container.children).forEach(positionToast);
  }

  function ensureToastRepositionListeners() {
    if (toastRepositionBound) return;
    toastRepositionBound = true;
    window.addEventListener('scroll', repositionAllToasts, true);
    window.addEventListener('resize', repositionAllToasts);
  }

  /**
   * WCAG 2.4.3 (Focus Order): keyboard focus order must match the visual
   * presentation. The popover physically lives in document.body (for the
   * DOM-persistence reasons explained above), which puts it dead last in
   * natural tab order -- Tab from the quantity control would normally
   * skip straight past it to the next line item, even though visually
   * it's sitting right there underneath. This intercepts Tab to route
   * focus through the popover's close button first, then continues on to
   * wherever focus would naturally have gone next, so the keyboard
   * experience matches what's on screen.
   */
  var QTY_STEPPER_WRAPPER_SELECTOR = '.quantity-selector, .quantity__input-group, .quantity';
  var FOCUSABLE_SELECTOR =
    'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var focusOrderListenerBound = false;

  function getFocusableElements(root) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll(FOCUSABLE_SELECTOR)).filter(function (el) {
      return el.offsetParent !== null; // excludes hidden/display:none elements
    });
  }

  function getStepperWrapper(input) {
    return input.closest(QTY_STEPPER_WRAPPER_SELECTOR) || input.parentElement;
  }

  function closeAndReturnFocus(variantId) {
    var anchor = toastAnchors[variantId];
    removeMinQtyNotice(variantId);
    if (anchor && anchor.isConnected) anchor.focus();
  }

  function ensureFocusOrderListener() {
    if (focusOrderListenerBound) return;
    focusOrderListenerBound = true;
    document.addEventListener('keydown', handleToastTabKey, true);
  }

  function handleToastTabKey(evt) {
    if (evt.key === 'Escape') {
      handleToastEscapeKey(evt);
      return;
    }
    if (evt.key !== 'Tab') return;
    var active = document.activeElement;
    if (!active) return;

    var toastContainer = document.getElementById(TOAST_CONTAINER_ID);

    // Tabbing INSIDE an open popover (its only focusable child is the
    // close button) -- redirect forward/backward instead of letting the
    // browser fall through to wherever document.body puts it next.
    if (toastContainer && toastContainer.contains(active)) {
      var toast = active.closest('[data-variant-id]');
      if (!toast) return;
      var variantId = toast.dataset.variantId;
      var anchor = toastAnchors[variantId];
      if (!anchor) return;
      var wrapper = getStepperWrapper(anchor);

      evt.preventDefault();
      if (evt.shiftKey) {
        var wrapFocusables = getFocusableElements(wrapper);
        (wrapFocusables[wrapFocusables.length - 1] || anchor).focus();
      } else {
        var next = findNextFocusableAfter(wrapper);
        if (next) next.focus();
      }
      return;
    }

    if (evt.shiftKey) return; // only intercept forward Tab out of a stepper

    // Tabbing OUT of the last focusable control in a quantity stepper
    // that currently has an open popover -- send focus into the popover
    // first before it would otherwise continue to the next line item.
    var openVariantId = null;
    Object.keys(toastAnchors).forEach(function (vid) {
      var anchorInput = toastAnchors[vid];
      if (!document.getElementById('tier-moq-toast-' + vid)) return;
      var wrapper = getStepperWrapper(anchorInput);
      if (wrapper && wrapper.contains(active)) openVariantId = vid;
    });
    if (!openVariantId) return;

    var stepperWrapper = getStepperWrapper(toastAnchors[openVariantId]);
    var stepperFocusables = getFocusableElements(stepperWrapper);
    var isLast = stepperFocusables[stepperFocusables.length - 1] === active;
    if (!isLast) return;

    var openToast = document.getElementById('tier-moq-toast-' + openVariantId);
    var closeBtn = openToast && openToast.querySelector('button');
    if (closeBtn) {
      evt.preventDefault();
      closeBtn.focus();
    }
  }

  /**
   * Escape dismisses the popover from anywhere focus lands in that line's
   * quantity stepper (input, minus, or plus) -- not only once focus has
   * already been tabbed all the way into the close button. This matches
   * the pattern most screen reader users expect: focus the field, hear
   * the alert announced (via role="alert" or aria-describedby), press
   * Escape right away to dismiss it, without an extra Tab first.
   */
  function handleToastEscapeKey(evt) {
    var active = document.activeElement;
    if (!active) return;

    var toastContainer = document.getElementById(TOAST_CONTAINER_ID);

    // Focus is already inside the popover itself (e.g. on the close button).
    if (toastContainer && toastContainer.contains(active)) {
      var toast = active.closest('[data-variant-id]');
      if (toast) {
        evt.preventDefault();
        closeAndReturnFocus(toast.dataset.variantId);
      }
      return;
    }

    // Focus is somewhere in the quantity stepper for a line that
    // currently has an open popover.
    Object.keys(toastAnchors).forEach(function (vid) {
      if (!document.getElementById('tier-moq-toast-' + vid)) return;
      var wrapper = getStepperWrapper(toastAnchors[vid]);
      if (wrapper && wrapper.contains(active)) {
        evt.preventDefault();
        closeAndReturnFocus(vid);
      }
    });
  }

  function findNextFocusableAfter(el) {
    if (!el) return null;
    var toastContainer = document.getElementById(TOAST_CONTAINER_ID);
    var all = getFocusableElements(document.body).filter(function (f) {
      return !toastContainer || !toastContainer.contains(f);
    });
    for (var i = 0; i < all.length; i++) {
      if (el.compareDocumentPosition(all[i]) & Node.DOCUMENT_POSITION_FOLLOWING) {
        return all[i];
      }
    }
    return null;
  }

  function addDescribedBy(input, id) {
    var existing = input.getAttribute('aria-describedby');
    var ids = existing ? existing.split(/\s+/).filter(Boolean) : [];
    if (ids.indexOf(id) === -1) ids.push(id);
    input.setAttribute('aria-describedby', ids.join(' '));
  }

  function removeDescribedBy(input, id) {
    var existing = input.getAttribute('aria-describedby');
    if (!existing) return;
    var ids = existing.split(/\s+/).filter(function (x) { return x && x !== id; });
    if (ids.length) {
      input.setAttribute('aria-describedby', ids.join(' '));
    } else {
      input.removeAttribute('aria-describedby');
    }
  }

  function showMinQtyNotice(lineItem, variantId, min) {
    var container = ensureToastContainer();
    ensureToastRepositionListeners();
    ensureFocusOrderListener();

    var qtyControl = lineItem.querySelector(
      'input[name="updates[]"], input.quantity-selector__input, input.quantity__input, input[name^="quantity"], [data-quantity-input]'
    ) || findQtyInputForVariant(variantId);
    if (qtyControl) toastAnchors[variantId] = qtyControl;

    var toastId = 'tier-moq-toast-' + variantId;
    var toast = document.getElementById(toastId);

    if (!toast) {
      toast = document.createElement('div');
      toast.id = toastId;
      toast.dataset.variantId = variantId;
      toast.style.cssText = [
        'position: fixed',
        'z-index: 99999',
        'background: #fff0f0',
        'border: 1px solid #e0a0a0',
        'border-left: 4px solid #b3261e',
        'border-radius: 6px',
        'padding: 10px 34px 10px 14px',
        'font-size: 13px',
        'line-height: 1.4',
        'color: #7a1f1f',
        'box-shadow: 0 2px 10px rgba(0,0,0,0.15)',
        'width: min(85vw, 300px)'
      ].join(';');

      var textEl = document.createElement('span');
      textEl.className = 'tier-moq-toast-text';
      toast.appendChild(textEl);

      // role="alert" gets this announced by screen readers the moment it
      // appears, without needing focus to move there first.
      toast.setAttribute('role', 'alert');

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.setAttribute('aria-label', 'Dismiss minimum quantity notice');
      closeBtn.textContent = '\u00d7';
      closeBtn.style.cssText = [
        'position: absolute',
        'top: 4px',
        'right: 6px',
        'background: none',
        'border: none',
        'font-size: 18px',
        'line-height: 1',
        'color: #7a1f1f',
        'cursor: pointer',
        'padding: 4px 6px'
      ].join(';');
      closeBtn.addEventListener('click', function () {
        closeAndReturnFocus(variantId);
      });
      toast.appendChild(closeBtn);

      container.appendChild(toast);
    }

    toast.querySelector('.tier-moq-toast-text').textContent =
      'Min qty for this price tier is ' + min + '. For lower qty, adjust on product page.';

    if (qtyControl) {
      addDescribedBy(qtyControl, toastId);
      if (!qtyControl.hasAttribute('aria-invalid')) {
        qtyControl.dataset.tierMoqSetAriaInvalid = 'true';
      }
      qtyControl.setAttribute('aria-invalid', 'true');
    }

    positionToast(toast);
  }

  function removeMinQtyNotice(variantId) {
    var toastId = 'tier-moq-toast-' + variantId;
    var toast = document.getElementById(toastId);
    if (toast) toast.remove();

    var anchor = toastAnchors[variantId];
    if (anchor) {
      removeDescribedBy(anchor, toastId);
      if (anchor.dataset.tierMoqSetAriaInvalid) {
        anchor.removeAttribute('aria-invalid');
        delete anchor.dataset.tierMoqSetAriaInvalid;
      }
    }

    delete toastAnchors[variantId];
  }
})();